import { useEffect, useState } from 'react';
import {
  readStoredCookieYesConsent,
  subscribeToCookieYesConsent,
} from 'utils/cookieYesConsent';

export const useCookieYesConsent = (): string[] => {
  const [accepted, setAccepted] = useState<string[]>(
    readStoredCookieYesConsent
  );

  useEffect(() => subscribeToCookieYesConsent(setAccepted), []);

  return accepted;
};
